import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './PlanSuccess.css';

const PlanSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [successData, setSuccessData] = useState(null);
  const [error, setError] = useState('');
  const [showVerificationPopup, setShowVerificationPopup] = useState(false);

  const companyId = searchParams.get('company_id');
  const planId = searchParams.get('plan_id');
  const noOfWorkers = searchParams.get('no_of_workers');

  useEffect(() => {
    if (companyId && planId && noOfWorkers) {
      fetchPlanSuccess();
    } else {
      setError('Invalid success parameters. Missing required data.');
      setLoading(false);
    }
  }, [companyId, planId, noOfWorkers]);

  const fetchPlanSuccess = async () => {
    try {
      setLoading(true);
      setError('');

      const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/plan-successes?company_id=${encodeURIComponent(companyId)}&plan_id=${encodeURIComponent(planId)}&no_of_workers=${encodeURIComponent(noOfWorkers)}`;
      
      console.log('Plan Success API URL:', apiUrl);

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      console.log('Response status:', response.status);

      const data = await response.json();

      if (data.status && data.data) {
        setSuccessData(data.data);
        setShowVerificationPopup(true);
        console.log('Plan success data:', data.data);
      } else {
        setError(data.message || 'Failed to confirm plan purchase. Please contact support.');
      }
    } catch (err) {
      console.error('Plan success error:', err);
      setError('Failed to confirm plan purchase. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoToDashboard = () => {
    navigate('/');
  };

  const handleContactSupport = () => {
    navigate('/');
  };

  const handleClosePopup = () => {
    setShowVerificationPopup(false);
  };

  if (loading) {
    return (
      <div className="plan-success-container">
        <div className="success-card">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Confirming your plan purchase...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="plan-success-container">
        <div className="success-card">
          <div className="error-icon">❌</div>
          <h2>Plan Purchase Confirmation Failed</h2>
          <p className="error-message">{error}</p>
          <div className="error-actions">
            <button 
              className="btn-secondary" 
              onClick={fetchPlanSuccess}
            >
              Try Again
            </button>
            <button 
              className="btn-primary" 
              onClick={handleContactSupport}
            >
              Contact Support
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="plan-success-container">
      {showVerificationPopup && (
        <div className="popup-overlay" role="dialog" aria-modal="true" aria-labelledby="verification-title">
          <div className="verification-popup">
            <h3 id="verification-title">Almost Done!</h3>
               
              <p className="popup-message">
               To verify your email, click on the verification request email from info@eworxs.app
            </p>
            <div className="popup-actions">
              <button className="btn-primary" onClick={handleClosePopup}>
                I&rsquo;ll Verify Now
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="success-card">
        
        <h2>Plan Purchased Successfully!</h2>
        <p className="success-message">{successData?.message || 'Your plan has been activated successfully.'}</p>

        <div className="plan-details">
          <h3>Plan Details</h3>
          <div className="detail-row">
            <span className="label">Company ID:</span>
            <span className="value">{successData?.company_id}</span>
          </div>
          <div className="detail-row">
            <span className="label">Plan ID:</span>
            <span className="value">{successData?.plan_id}</span>
          </div>
          <div className="detail-row">
            <span className="label">Number of Workers:</span>
            <span className="value">{successData?.no_of_workers}</span>
          </div>
          <div className="detail-row">
            <span className="label">Status:</span>
            <span className="value status-active">{successData?.status}</span>
          </div>
        </div>

        <div className="success-actions">
          <button
            className="btn-primary"
            onClick={handleGoToDashboard}
          >
            Go to Home
          </button>
          <button
            className="btn-secondary"
            onClick={handleContactSupport}
          >
            Contact Support
          </button>
        </div>

       
      </div>
    </div>
  );
};

export default PlanSuccess;
